<div class="information-dialog" fxLayout="column" fxLayoutAlign="start start">
  <span class="dialog-title">
    {{ data?.title }}
  </span>
  <div class="dialog-message" [innerHTML]="data?.message"></div>
  <div class="dialog-buttons" fxLayout="row" fxLayoutAlign="end end">
    <button mat-stroked-button type="button" class="stroked-button" fxLayoutAlign="center center" (click)="onClose()">{{data?.closeButtonText}}</button>
  </div>
</div>
